export default {"src":"/_next/static/media/favicon.ec9db017.ico","height":16,"width":16};